import http from "@/apis/http";
import url from "@/config/url";

const api = url.tgBusiness.level_distributed;

export default {
  getData: (params) => http.post(api.agent, params),
  getColumns: (params) => http.post(api.columns, params),
  getDistributed: (params) => http.post(api.search, params),
  getMember: (params) => http.post(api.member, params),
};
